import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=cda33f7e&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=cda33f7e&prod&scoped=scoped&lang=less"
import style1 from "./Details.vue?vue&type=style&index=1&id=cda33f7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda33f7e",
  null
  
)

export default component.exports